import { useCallback } from 'react'
import { Button } from 'components'
import { useAccountActions } from 'hooks/userHooks'
import { useAlert } from 'providers/confirmationModal'
import { noop } from 'utils'
import { BasicConfirmationModal } from 'components/ConfirmationModals/BasicConfirmationModal'
import { useUsersActions } from 'providers'
import { TMATTEnrollModal } from 'components/ConfirmationModals/TMATTEnrollModal'
import { TMATTCourseOptions } from 'types'
export type EnrollTMATTBtnProps = {
  userId: string
  disabled?: boolean
  onDone?: (message: string) => void
  onError?: (message: string) => void
}
export const EnrollTMATTBtn = ({
  disabled = false,
  userId,
  onDone = noop,
  onError = noop,
}: EnrollTMATTBtnProps) => {
  const [, { enrollTMATT }] = useAccountActions()
  const { read: readUser } = useUsersActions()
  const {
    createAlert,
    finalizeConfirm,
    abortConfirm,
    handleCancel,
    setDisabled,
    interceptConfirm,
  } = useAlert()
  const enrollUser = useCallback(
    async ({ course }: TMATTCourseOptions) => {
      //needs to be a .then because when the user updates, this component won't exist, but the modal still will need to be closed

      await enrollTMATT({ userId: userId, course: course })
      await new Promise((res, rej) => {
        setTimeout(
          () =>
            readUser({ id: userId })
              .then(() => {
                res(true)
              })
              .catch((error) => {
                rej(error)
              }),
          2000
        )
      })
    },
    [userId, readUser, enrollTMATT]
  )
  const setCourse = useCallback(
    (course: TMATTCourseOptions) => {
      if (course === undefined) {
        setDisabled(true)
      } else {
        setDisabled(false)
        interceptConfirm(() => {
          finalizeConfirm()
          setTimeout(() => {
            createAlert({
              content: (
                <BasicConfirmationModal
                  header="Please confirm new course"
                  body={`Teacher will be set to start the ${course.label}. Is this correct?`}
                  handleCancel={handleCancel}
                />
              ),
              confirmText: 'Confirm',
            })
            interceptConfirm(() => {
              enrollUser(course)
                .then(() => {
                  finalizeConfirm()
                  onDone('Teacher has been successfully enrolled')
                })
                .catch((e) => {
                  abortConfirm('Enroll teacher failed. Please try again!')
                  onError('Enroll teacher failed. Please try again!')
                })
            })
          }, 10)
        })
      }
    },
    [
      setDisabled,
      interceptConfirm,
      finalizeConfirm,
      createAlert,
      handleCancel,
      enrollUser,
      onDone,
      abortConfirm,
      onError,
    ]
  )

  const handleClick = () => {
    createAlert({
      content: (
        <TMATTEnrollModal
          name="TMATTEnroll"
          set={setCourse}
          cancel={handleCancel}
        />
      ),
      confirmText: 'Save',
    })
    setDisabled(true) // Setting to true after modal is created because it starts with nothing selected
  }

  return (
    <Button
      type="button"
      variant="buttons.outline"
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 50,
      }}
      disabled={disabled}
      onClick={handleClick}>
      <span>Enroll in Training</span>
    </Button>
  )
}
